import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAppConfig } from '../contexts/AppConfigContext';
import SafeIcon from '../common/SafeIcon';
import { FiTool, FiRefreshCw } from 'react-icons/fi';

// Bypass paths - never trap the user mid-OAuth or lock the admin out of the
// kill-switch they need to flip.
const isExempt = (pathname) =>
  pathname === '/admin' ||
  pathname.startsWith('/admin/') ||
  pathname.startsWith('/auth/callback');

export default function MaintenanceGate({ children }) {
  const { config, loading, refresh } = useAppConfig();
  const location = useLocation();

  if (loading || !config) {
    // Render a neutral splash while we resolve config to avoid a flash where
    // children mount and then get replaced by the maintenance screen.
    return (
      <div className="min-h-screen bg-app flex items-center justify-center">
        <div className="w-10 h-10 border-2 border-accent border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  const enabled = config.maintenance_mode === true || config.maintenance_mode === 'true';
  if (!enabled || isExempt(location.pathname)) {
    return children;
  }

  return (
    <div className="min-h-screen bg-app flex items-center justify-center px-6">
      <div className="bg-card border border-border-subtle rounded-2xl shadow-card max-w-md w-full p-8 text-center">
        <div className="w-14 h-14 mx-auto mb-5 bg-accent/10 rounded-2xl flex items-center justify-center">
          <SafeIcon icon={FiTool} className="w-7 h-7 text-accent" />
        </div>
        <h1 className="text-2xl font-bold text-text-primary mb-3">Under maintenance</h1>
        <p className="text-text-secondary leading-relaxed mb-6 whitespace-pre-line">
          {config.maintenance_message || "We'll be back shortly. Thanks for your patience."}
        </p>
        <button
          type="button"
          onClick={() => refresh()}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-surface border border-border-subtle text-text-secondary hover:bg-card transition-colors text-sm font-medium"
        >
          <SafeIcon icon={FiRefreshCw} className="w-4 h-4" />
          Check again
        </button>
      </div>
    </div>
  );
}
